import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import backk from './images/backk.png'; 

const Rosas = () => {
  const navigate = useNavigate();
  const [userEmail, setUserEmail] = useState(null);

  const buttonStyle = {
    backgroundColor: '#E11584',
    color: '#fff',
    padding: '10px 20px',
    fontSize: '16px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    marginTop: '20px',
    width: '150px',
  };

  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '100vh',
    justifyContent: 'flex-start',
    paddingTop: '50px',
  };

  const headingStyle = {
    color: '#E11584',
    fontSize: '32px',
    fontWeight: 'bold',
    marginBottom: '40px',
  };

  const radioContainerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '15px',
    margin: '20px 0',
  };

  useEffect(() => {
    const email = sessionStorage.getItem('userEmail');
    if (!email) {
      navigate('/signin');
    } else {
      setUserEmail(email);
    }
  }, [navigate]);

  const handleSetUpClick = () => {
    navigate('/SetUpp');
  };

  const handleOptionChange = (value) => {
    if (value === 'FaceDetection') {
      navigate('/FaceDetection');
    } else if (value === 'MotionDetection') {
      navigate('/MotionDetection');
    }
  };

  const handleBackClick = () => {
    navigate(-1); // Navigate to the previous page
  };

  return (
    <div style={{ 
      background: 'linear-gradient(to bottom, #fff7ad, #ffa9f9)', 
      minHeight: '100vh', 
      padding: '20px', 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center',
      textAlign: 'center' 
    }}>
      <div style={containerStyle}>
        <h1 style={headingStyle}>Rosa S Main Screen</h1>
        
        {userEmail && (
          <p 
            style={{ 
              color: '#E11584', 
              fontSize: '20px', 
              textAlign: 'center', 
              marginBottom: '20px' 
            }}
          >
            Signed in as: {userEmail}
          </p>
        )}

        <button style={buttonStyle} onClick={handleSetUpClick}>Set Up</button>
        <br />

        <div style={radioContainerStyle}>
          <label style={{ color: '#E11584' }}>
            <input 
              type="radio" 
              value="FaceDetection" 
              name="navigation" 
              onChange={() => handleOptionChange('FaceDetection')} 
              style={{ marginRight: '5px' }} 
            />
            Face Detection
          </label>

          <label style={{ color: '#E11584' }}>
            <input 
              type="radio" 
              value="MotionDetection" 
              name="navigation" 
              onChange={() => handleOptionChange('MotionDetection')} 
              style={{ marginRight: '5px' }} 
            />
            Motion Detection
          </label>
        </div>

        <button
          type="button"
          onClick={handleBackClick}
          style={{
            backgroundColor: 'transparent',
            border: 'none',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <img src={backk} width="30" height="40" alt="Back" />
        </button>
      </div>
    </div>
  );
};

export default Rosas;
